import { OverlayContainer } from '@angular/cdk/overlay';
import { Inject, Injectable, SkipSelf } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';

@Injectable()
export class EigOverlayContainer extends OverlayContainer {

    subContainer: HTMLElement;

    constructor(
        @Inject(DOCUMENT) document: any,
        @SkipSelf() private overlayContainer: OverlayContainer,
        platform: Platform,) {
        super(document, platform);
    }

    getContainerElement(): HTMLElement {
        if (this.subContainer === undefined) {
            return this.overlayContainer.getContainerElement();
        }

        return this.subContainer;
    }
    setContainer(ele: HTMLElement): void {
        this.subContainer = ele;
    }

    removeSubContainer(): void {
        this.subContainer = undefined;
    }
}
